import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=7e2707ca&scoped=true&"
import script from "./curriculum.vue?vue&type=script&lang=js&"
export * from "./curriculum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2707ca",
  null
  
)

export default component.exports